<div class="file-list">
  @for (item of files; track item) {
    <div
      class="file-list-item"
      data-cy="file-list-item">
      <app-file-preview [extension]="getExtension(item.file)"></app-file-preview>
      <div class="file-info">
        <span class="file-info name" data-cy="file-list-item-name">{{item.file.name}}</span>
        <span class="file-info size" data-cy="file-list-item-size">{{convertBytesToKilobytes(item.file.size)}}
        KB</span>
      </div>
      <div class="download-button">
        <button class="btn-text-link"
          [disabled]="item.isDownloading"
          (click)="download(item)"
          data-cy="file-list-download-button">
          <span class="iwp-icon-gen_download"></span>Download</button>
          @if (item.isDownloading) {
            <app-loading-spinner class="button-spinner"
              data-cy="file-list-item-spinner"
            ></app-loading-spinner>
          }
        </div>
      </div>
    }
  </div>
